const selectors = {
    readMoreBtn: document.querySelector('[data-readMoreBtn]'),
    readMoreContainer: document.querySelector('[data-readMoreContainer]')
  };
  class templateCollectionJS {
    constructor() {
        this.readMore();
        var swatchSizes = document.querySelectorAll('.swatch-data-mobile');
        (swatchSizes.length > 0) && this.showSwatchSizes();
        this.manageInfiniteScroll();
        this.addToCartFunction();
        this.continueShoppingButton();

        window.addEventListener('scroll', function() {
            if (window.innerWidth > 991) {
                var height = this.document.querySelector('.desktop-navbar').clientHeight;
            } else {
                var height = this.document.querySelector('.desktop-header').clientHeight - 5;
                var titleHeight = document.querySelector('.shopify-section.collection-grid-section .collection-page-title.sticky-top').clientHeight;
                document.querySelector('.sticky-top.mobile-filter-wrapper').style.top = (height + titleHeight - 5) + 'px';
            }
            (document.querySelector('.shopify-section.collection-grid-section .collection-page-title.sticky-top') != null) && (document.querySelector('.shopify-section.collection-grid-section .collection-page-title.sticky-top').style.top = height + 'px');
        })
    }

    showSwatchSizes() {
        window.updateCollectionGrids = function() {
    
            var productSwatches = document.querySelectorAll('.product-card-swtach-slider .swiper-wrapper a.swiper-slide img');
            if (productSwatches.length > 0) {
                productSwatches.forEach((item) => {
                    item.addEventListener('click', function(e) {
                        var dataId = item.getAttribute('data-img');
                        var dataIdSrc = item.getAttribute('data-img-src');
                        item.closest('.collection-listing-product-grid').querySelectorAll(".swatch-data-mobile .swatch-data-details:not(d-none)").forEach((i) => {i.classList.add('d-none')})
                        item.closest('.collection-listing-product-grid').querySelector(".swatch-data-mobile .swatch-data-details[data-swatch='"+dataId+"']").classList.remove('d-none')
                        var productGrid = item.closest('.collection-listing-product-grid');
                        if(productGrid != null) {
                            var imgProduct = productGrid.querySelector('.product-card-image img');
                            imgProduct.setAttribute('srcset', dataIdSrc);
                        }
                    })
                })
            }
        }
        window.updateCollectionGrids();
    }

    readMore(){
        if(selectors.readMoreBtn){
            selectors.readMoreBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                let currentTarget = e.target;
                let readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
                if(readMoreEle){ 
                    if(selectors.readMoreContainer.classList.contains('open')){
                        Utility.toggleElement(selectors.readMoreContainer, 'close');
                        currentTarget.innerHTML = 'Read More'
                    }else{
                        Utility.toggleElement(selectors.readMoreContainer, 'open');
                        currentTarget.innerHTML = 'Read Less'
                    }
                }
            });
        }
    }

    manageInfiniteScroll() {
        window.setManageInfiniteScroll = function(){
            let dataPaginationBtn = document.querySelector('[data-pagination]');
            if (dataPaginationBtn != null) {
                const onIntersection = (entries) => {
                    for (const entry of entries) {
                        if (entry.isIntersecting) {
                            (document.querySelector('#load-more[data-pagination]') != null) && document.querySelector('[collection-loading-image]').classList.remove('d-none');
                            (document.querySelector('#load-more[data-pagination]') != null) && document.querySelector('#load-more[data-pagination]').click(); 
                        }
                    }
                };
                const observer = new IntersectionObserver(onIntersection);
                observer.observe(dataPaginationBtn); 
            }
        }
        window.setManageInfiniteScroll();
    }

    addToCartFunction() {
        window.setupAddToCartFunction = function() {
            var sizeOptions = document.querySelectorAll('.product-sizes .product-card-size-varinat');
            if(sizeOptions.length > 0) {
                sizeOptions.forEach(item => {
                    item.addEventListener('click', function(e) {
                        var innerVars = item.closest('.product-sizes').querySelectorAll('.product-card-size-varinat');
                        if (innerVars.length > 0) {
                            innerVars.forEach(childVar => { childVar.classList.remove('selected-var'); })
                        }
                        item.classList.add('selected-var');
                        (item.closest('.grid-addtocart-wrapper') != null) && item.closest('.grid-addtocart-wrapper').querySelector('.add--to--cart').classList.remove('disabled');
                    })
                })
            }
        }
        window.setupAddToCartFunction();
    }

    continueShoppingButton() {
        
        var csActivated = localStorage.getItem('cs-activate');

        if (csActivated == 'false' || csActivated === undefined || csActivated === null) {
            localStorage.setItem('cs-url', `${window.location.href}`)
            localStorage.setItem('cs-page', '');
            localStorage.setItem('cs-product-id', '');
        }
        window.setupContinueShoppingButton = function() {
            var allProductGrids = document.querySelectorAll('.collection-listing-product-grid');
            allProductGrids.forEach(item => {
                item.addEventListener('click', (e) => {
                    var productId = item.getAttribute('data-pr-id');
                    var url_string = window.location.href; 
                    var url = new URL(url_string);
                    var pageid = url.searchParams.get("page");
                    var url = window.location.href;
                    
                    localStorage.setItem('cs-url', `${window.location.href}`);
                    localStorage.setItem('cs-page', pageid);
                    localStorage.setItem('cs-product-id', productId);
                })
            })
        }
        window.setupContinueShoppingButton();
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

window.removeParam = function(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}